import React from "react";
import { Minus, TrendingDown, TrendingUp } from "lucide-react";
import { CallSentiment } from "@/model/interface/AiAgent";

/**
 * Call sentiment pill. Shared by call history, the transcript dialog, and live call cards so the
 * same sentiment always reads identically — it was previously duplicated in each of them.
 * Uses the .status-pill-* theme classes, so it stays legible in light and dark.
 */
const SENTIMENT_CONFIG: Record<
  CallSentiment,
  { label: string; icon: React.ElementType; pill: string }
> = {
  INTERESTED: { label: "Interested", icon: TrendingUp, pill: "status-pill-success" },
  NEUTRAL: { label: "Neutral", icon: Minus, pill: "status-pill-neutral" },
  NOT_INTERESTED: { label: "Not interested", icon: TrendingDown, pill: "status-pill-destructive" },
};

export default function SentimentBadge({ sentiment }: { sentiment: CallSentiment }) {
  const config = SENTIMENT_CONFIG[sentiment];
  if (!config) return null;
  const Icon = config.icon;
  return (
    <span className={config.pill}>
      <Icon className="h-3 w-3" />
      {config.label}
    </span>
  );
}
